import React from 'react';
import { AlertDisplayField } from '@components/Alerts/AlertDisplayField/AlertDisplayField';
import AlertContainer from '@components/Alerts/presentationComponents/AlertContainer';
import AlertHeader from '@components/Alerts/presentationComponents/AlertHeader';
import AlertTitle from '@components/Alerts/presentationComponents/AlertTitle';
import AlertDetails from '@components/Alerts/presentationComponents/AlertDetails';
import AlertHeaderNote from '@components/Alerts/presentationComponents/AlertHeaderNote';
import AlertUser from '@components/Alerts/presentationComponents/AlertUser';
import AlertDate from '@components/Alerts/presentationComponents/AlertDate';
import Chip from '@components/Chip/Chip';
import { useGetRevisionInfo } from '@components/Alerts/hooks/useGetRevisionInfo/useGetRevisionInfo';
import { RevisionStatus } from '@interfaces/SurgeryRequest/RevisionStatusEnum';

const RescheduledAlert: React.FC = () => {
	const {
		filteredRevisions, name, dateCreatedDisplay, requestedAppointmentDate, requestedAppointmentTime, locationDisplay, previousDisplayDate, previousDisplayTime, previousFIN
	} = useGetRevisionInfo(RevisionStatus.RESCHEDULED);

	if (!filteredRevisions.length) {
		return null;
	}

	return (
		<AlertContainer>
			<AlertHeader>
				<Chip data-field="rescheduledCaseAlert-caseDetails-rescheduledChip" color="secondary" label="Rescheduled" />
				<AlertHeaderNote>
					This procedure has been rescheduled
				</AlertHeaderNote>
			</AlertHeader>
			<AlertTitle>
				<AlertUser>
					{name}
				</AlertUser>
				<AlertDate>
					{dateCreatedDisplay}
				</AlertDate>
			</AlertTitle>
			<AlertDetails>
				<AlertDisplayField
					label="Requested Surgery Date:"
				>
					{requestedAppointmentDate}
				</AlertDisplayField>
				<AlertDisplayField
					label="Requested Surgery Time:"
				>
					{requestedAppointmentTime}
				</AlertDisplayField>
				<AlertDisplayField
					label="Appointment Location:"
				>
					{locationDisplay}
				</AlertDisplayField>
				<AlertDisplayField
					label="Previous surgery date:"
				>
					{previousDisplayDate}
				</AlertDisplayField>
				<AlertDisplayField
					label="Previous surgery time:"
				>
					{previousDisplayTime}
				</AlertDisplayField>
				<AlertDisplayField
					label="Previous FIN#:"
				>
					{previousFIN || '--'}
				</AlertDisplayField>
			</AlertDetails>
		</AlertContainer>
	);
};

export default RescheduledAlert;
